/** H5 / 小程序法律文档（内容与 longfans 平台站 platformLegalContent 对齐，域名表述适配移动端） */

export type H5LegalSlug = "user-agreement" | "privacy" | "compliance";

export type LegalSection = {
  heading: string;
  paragraphs: string[];
};

export type LegalDocument = {
  title: string;
  updatedAt: string;
  preamble?: string[];
  sections: LegalSection[];
};

export const H5_LEGAL_TITLES: Record<H5LegalSlug, string> = {
  "user-agreement": "用户协议",
  privacy: "隐私政策",
  compliance: "法律合规",
};

const OPERATOR = "上海魔法向量人工智能技术有限公司";
const PLATFORM = "龙粉社";
const WEBSITE =
  "m.longfans.com、www.longfans.com 及其子域名，以及龙粉社微信小程序等客户端形态";

export const H5_LEGAL_DOCS: Record<H5LegalSlug, LegalDocument> = {
  "user-agreement": {
    title: "用户协议",
    updatedAt: "2025年6月15日",
    preamble: [
      `欢迎使用${PLATFORM}（以下简称「本平台」）。${PLATFORM}是由${OPERATOR}（以下简称「我们」）运营的财经资讯与知识分享平台。`,
      "请您在注册、登录或使用本平台服务前，仔细阅读并充分理解本协议全部内容。您点击同意、完成注册或实际使用本平台服务，即视为您已阅读并同意接受本协议约束。若您不同意本协议，请停止使用本平台。",
    ],
    sections: [
      {
        heading: "一、定义",
        paragraphs: [
          `「本平台」指由我们运营的${PLATFORM}网站及相关客户端、小程序等形态，域名为 ${WEBSITE}。`,
          "「用户」指完成注册或实际使用本平台服务的自然人。",
          "「创作者空间」指经平台审核开通、由创作者独立运营并向其关注用户展示内容的专属空间。",
          "「平台站空间」指在平台统一入口下、以八位数字空间号标识的创作者空间。",
          "「内容」指用户在本平台发布、上传、传播的文字、图片、音视频、数据展示及其他信息。",
        ],
      },
      {
        heading: "二、账户注册与使用",
        paragraphs: [
          "您应使用本人真实、合法、有效的手机号码完成注册与登录。您应对账户下的全部行为负责，并妥善保管账户信息及验证码，不得出借、转让或授权他人使用。",
          "如发现账户被盗用或存在异常，您应及时通知我们。因您保管不善导致的损失，由您自行承担。",
          "我们有权基于合规、安全或运营需要，对异常注册、批量注册、恶意刷量等行为采取限制、冻结或注销等措施。",
        ],
      },
      {
        heading: "三、服务内容",
        paragraphs: [
          `${PLATFORM}向用户提供财经资讯浏览、知识内容阅读、创作者空间访问、笔记与情报等工具能力，以及平台不时上线的其他功能。具体功能以页面实际展示为准。`,
          "本平台提供的信息与工具仅供学习、研究与交流参考，不构成任何投资建议、要约或承诺。您应基于自身判断独立作出决策，并自行承担相应风险。",
          "我们有权根据业务发展、法律法规要求或系统维护需要，调整、暂停或终止部分或全部服务，并将通过合理方式告知用户。",
        ],
      },
      {
        heading: "四、用户行为规范",
        paragraphs: [
          "您在使用本平台时，应遵守法律法规、监管规定及公序良俗，不得发布、传播或从事以下行为：",
          "（1）危害国家安全、泄露国家秘密、颠覆国家政权、破坏国家统一；",
          "（2）散布谣言、虚假信息，或传播可能误导投资者的内容；",
          "（3）明示或暗示推荐具体证券、承诺收益、代客理财、非法荐股或从事其他未经许可的证券投资咨询活动；",
          "（4）侵犯他人知识产权、名誉权、隐私权或其他合法权益；",
          "（5）发布色情、暴力、赌博、诈骗等违法或不良信息；",
          "（6）利用技术手段干扰平台正常运行、爬取数据或进行其他破坏性行为。",
          "我们有权对违规内容采取删除、屏蔽、限制功能、暂停或终止服务等措施，并依法向主管部门报告。",
        ],
      },
      {
        heading: "五、知识产权",
        paragraphs: [
          "本平台界面设计、程序代码、商标标识、文档资料等知识产权归我们或相关权利人所有。未经书面许可，您不得复制、修改、传播或用于商业用途。",
          "您在本平台发布的内容，其知识产权归您或原始权利人所有。您授予我们在全球范围内、免费的、非独占的使用许可，以便为提供、展示、推广及存档本平台服务所必需。",
        ],
      },
      {
        heading: "六、免责声明",
        paragraphs: [
          "本平台展示的财经资讯、市场数据、第三方内容及用户生成内容，均不代表我们的立场或观点。我们不对其准确性、完整性、及时性作出保证。",
          "因网络故障、系统维护、不可抗力或第三方原因导致的服务中断、数据丢失或其他损失，我们在法律允许范围内不承担责任。",
          "您与其他用户或第三方之间的纠纷，由相关方自行解决；我们可在合理范围内提供必要协助，但不承担连带责任。",
        ],
      },
      {
        heading: "七、协议变更与终止",
        paragraphs: [
          "我们有权根据法律法规变化或业务需要修订本协议，修订后的协议将在本平台公布。若您继续使用服务，即视为接受修订内容。",
          "您可随时停止使用本平台并申请注销账户。我们亦可在您严重违反本协议或法律法规时，终止向您提供服务。",
        ],
      },
      {
        heading: "八、法律适用与争议解决",
        paragraphs: [
          "本协议的订立、执行与解释适用中华人民共和国法律。",
          "因本协议引起的争议，双方应友好协商；协商不成的，任何一方可向本公司住所地有管辖权的人民法院提起诉讼。",
        ],
      },
      {
        heading: "九、联系我们",
        paragraphs: [
          `如您对本协议有任何疑问，可通过本平台公示的联系方式与我们取得联系。运营主体：${OPERATOR}。`,
        ],
      },
    ],
  },
  privacy: {
    title: "隐私政策",
    updatedAt: "2025年6月15日",
    preamble: [
      `${OPERATOR}（以下简称「我们」）深知个人信息对您的重要性。本隐私政策说明我们在您使用${PLATFORM}（以下简称「本平台」，含移动网页、微信小程序等）时如何收集、使用、存储、共享及保护您的个人信息，以及您享有的相关权利。`,
      "请您在使用本平台前仔细阅读本政策。您使用或继续使用本平台，即表示您同意我们按照本政策处理您的个人信息。",
    ],
    sections: [
      {
        heading: "一、我们收集的信息",
        paragraphs: [
          "为向您提供注册登录、空间访问、内容浏览及创作者服务等基本功能，我们可能收集以下信息：",
          "（1）账户信息：手机号码、验证码校验结果、昵称、头像等您主动填写或上传的信息；",
          "（2）使用信息：访问记录、浏览偏好、搜索关键词、互动行为、设备型号、操作系统、浏览器类型、IP 地址、访问时间等日志信息；",
          "（3）创作者入驻信息：如您申请成为创作者，我们可能收集您的联系方式、社交媒体账号、身份证明材料等审核所需信息；",
          "（4）其他依法需收集的信息。",
          "我们不会主动收集与服务无关的敏感个人信息。若因特定功能确需收集，我们将另行告知并征得您的明示同意。",
        ],
      },
      {
        heading: "二、信息的使用目的",
        paragraphs: [
          "我们收集您的个人信息，用于以下目的：",
          "（1）完成账户注册、身份验证与安全风控；",
          "（2）向您提供、维护和改进本平台各项功能；",
          "（3）向您发送服务通知、验证码及必要的运营信息；",
          "（4）处理创作者入驻申请、资质审核与后续管理；",
          "（5）分析产品使用情况，优化用户体验与平台安全；",
          "（6）履行法律法规规定的义务，配合监管与执法要求；",
          "（7）经您同意的其他用途。",
        ],
      },
      {
        heading: "三、信息的共享与披露",
        paragraphs: [
          "我们不会向第三方出售您的个人信息。仅在以下情形下，我们可能共享或披露您的信息：",
          "（1）获得您的明确同意；",
          "（2）为完成您选择的服务，向必要的合作伙伴（如短信服务商、云存储服务商）提供，且其仅可在授权范围内使用；",
          "（3）根据法律法规、司法或行政机关的要求；",
          "（4）为保护本平台、用户或公众的合法权益所必需。",
          "我们要求第三方对您的信息承担保密义务，并采取适当的安全措施。",
        ],
      },
      {
        heading: "四、信息的存储与保护",
        paragraphs: [
          "您的个人信息原则上存储于中华人民共和国境内。如需跨境传输，我们将依法履行评估、告知及取得同意等义务。",
          "我们采用加密传输、访问控制、安全审计等技术和管理措施保护您的信息安全。",
          "我们仅在实现本政策所述目的所必需的期限内保留您的个人信息，法律法规另有规定的除外。",
        ],
      },
      {
        heading: "五、您的权利",
        paragraphs: [
          "您有权查询、更正、补充您的个人信息，有权撤回授权、注销账户或要求我们删除相关信息，法律法规另有规定的除外。",
          "您可通过本平台提供的功能入口或联系客服行使上述权利。我们将在合理期限内响应您的请求。",
          "注销账户后，我们将停止为您提供服务，并依法删除或匿名化处理您的个人信息。",
        ],
      },
      {
        heading: "六、未成年人保护",
        paragraphs: [
          "本平台主要面向成年人。若您为未满十八周岁的未成年人，请在监护人指导下阅读本政策并使用本平台。",
          "若我们发现未经监护人同意收集了未成年人的个人信息，将尽快删除相关数据。",
        ],
      },
      {
        heading: "七、政策更新",
        paragraphs: [
          "我们可能适时修订本隐私政策。重大变更将通过本平台显著位置提示。若您继续使用服务，即视为接受更新后的政策。",
        ],
      },
      {
        heading: "八、联系我们",
        paragraphs: [
          `如您对本隐私政策或个人信息处理有任何疑问、意见或投诉，可通过本平台公示的联系方式与我们联系。运营主体：${OPERATOR}。`,
        ],
      },
    ],
  },
  compliance: {
    title: "法律合规",
    updatedAt: "2025年6月15日",
    preamble: [
      `${PLATFORM}始终坚持合法合规经营，致力于为用户提供安全、透明、专业的财经资讯与知识分享环境。本页说明我们在业务运营中遵循的主要合规原则与要求。`,
    ],
    sections: [
      {
        heading: "一、合规经营承诺",
        paragraphs: [
          `${OPERATOR}依法设立并运营${PLATFORM}，遵守《中华人民共和国网络安全法》《中华人民共和国数据安全法》《中华人民共和国个人信息保护法》《中华人民共和国证券法》及相关金融监管、互联网信息服务等法律法规。`,
          "我们持续完善内部合规制度，建立内容审核、用户身份管理、数据安全与风险监测机制，确保平台业务在合法框架内开展。",
        ],
      },
      {
        heading: "二、证券与金融信息合规",
        paragraphs: [
          `${PLATFORM}定位为财经资讯与知识分享平台，不提供证券经纪、投资顾问、资产管理等需持牌经营的金融服务。`,
          "平台及创作者不得明示或暗示推荐具体证券买卖，不得承诺或保证投资收益，不得代客理财或从事非法证券投资咨询活动。",
          "平台展示的市场行情、财务数据、研究报告等信息来源于公开渠道或合法授权，仅供用户学习研究参考，不构成投资建议。",
          "用户应充分认识证券市场风险，独立作出投资决策并自行承担后果。",
        ],
      },
      {
        heading: "三、内容与创作者管理",
        paragraphs: [
          "我们建立内容审核与巡查机制，对用户及创作者发布的内容进行合规管理，对违法违规内容及时采取处置措施。",
          "创作者入驻须提交真实信息并通过平台审核，入驻后应持续遵守平台规则及法律法规，不得利用平台从事违法违规活动。",
          "对于涉及虚假陈述、操纵市场、内幕交易嫌疑或其他严重违规的内容或行为，我们将依法配合监管部门调查处置。",
        ],
      },
      {
        heading: "四、用户信息与数据安全",
        paragraphs: [
          "我们严格按照《个人信息保护法》等规定收集、使用和保护用户个人信息，详见《隐私政策》。",
          "我们采取技术与管理措施防范数据泄露、篡改与丢失，并限制内部人员对用户信息的访问权限。",
          "发生个人信息安全事件时，我们将依法及时告知用户并向主管部门报告。",
        ],
      },
      {
        heading: "五、未成年人与特殊群体保护",
        paragraphs: [
          "我们不对未成年人提供与其认知能力不相适应的证券投资相关内容推广。",
          "平台内容应表述清晰、客观，避免使用夸大、误导性语言，保护投资者特别是普通投资者的合法权益。",
        ],
      },
      {
        heading: "六、投诉与举报",
        paragraphs: [
          "如您发现平台内容或用户行为涉嫌违法违规，可通过本平台公示的渠道进行投诉或举报。",
          "我们将在收到有效举报后及时核查，并依法采取必要措施。对于恶意举报，我们保留追究法律责任的权利。",
        ],
      },
      {
        heading: "七、持续改进",
        paragraphs: [
          "我们将持续关注法律法规与监管政策变化，及时更新平台规则与合规措施，与用户、创作者共同维护健康有序的网络生态。",
          `运营主体：${OPERATOR}。`,
        ],
      },
    ],
  },
};

export const H5_LEGAL_NAV_SLUGS: H5LegalSlug[] = ["user-agreement", "privacy", "compliance"];

export function isH5LegalSlug(slug: string): slug is H5LegalSlug {
  return slug in H5_LEGAL_TITLES;
}
